import React from 'react';
import imprintDe from './imprint-de.md';
import imprintEn from './imprint-en.md';
import ReactMarkdown from 'react-markdown';
import { Box, Container, Typography } from '@material-ui/core';
import useMarkdown from '../utils/use-markdown';
import AppBackLink from '../components/BackLink';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export default function Imprint() {
  const { t } = useTranslation();
  const [text] = useMarkdown(i18next.language === 'de' ? imprintDe : imprintEn, [i18next.language]);

  return (
    <Container className="article">
      <Helmet>
        <title>{t('imprint-title')}</title>
        <meta name="description" content={t('imprint-description')} />
      </Helmet>
      <AppBackLink to="/" />
      <Box mb={4}>
        {i18next.language === 'de' && (
          <Typography variant="h1" className="with-bar terms-bar">
            Impressum
          </Typography>
        )}
        {i18next.language === 'en' && (
          <Typography variant="h1" className="with-bar terms-bar">
            Imprint
          </Typography>
        )}
      </Box>
      {text && <ReactMarkdown children={text} />}
    </Container>
  );
}
